import React, { Component } from 'react';
import styles from './ProblemSelector.scss';
import { withTranslation } from 'react-i18next';

class ProblemSelector extends Component {
  render() {
    const { t } = this.props;

    let items = null;
    items = this.props.problems.map((p, index) => (
      <li
        className={styles['c-problem-selector__list-item']}
        key={p.id}
      >
        <div className={styles['c-problem-selector__marker-div']}>
          <span
            className={styles['c-problem-selector__marker-box']}
            ck_selected={p.isCurrent ? 'true' : 'false'}
          />
          <span
            className={styles['c-problem-selector__marker']}
            ck_selected={p.isCurrent ? 'true' : 'false'}
          />
        </div>
        <div
          className={styles['c-problem-selector__icon']}
          problem_id={p.id}
          onClick={() => this.props.onProblemClick(p.id)}
          status={p.status}
        >
          {index + 1}
        </div>
        <div className={styles['c-problem-selector__balancer']}></div>
      </li>
    ));

    let points = this.props.problems.filter(p => p.isCurrent).reduce((acc, p) => acc + p.points, 0);
    return (
      <div className={styles['c-problem-selector']}>
        <div className={styles['c-problem-selector__points']}>
          <span>
            {points} {t('problem_selector.points')}
          </span>
        </div>
        <ul className={styles['c-problem-selector__plist']}>{items}</ul>
      </div>
    );
  }
}

export default withTranslation('interview_problem')(ProblemSelector);
